export interface MenuItem {
  id: string;
  name: string;
  link?: string;
  icon?: string;
  subMenu?: MenuItem[];
  requiredPermissions?: string[];
  showInMobile?: boolean;
}

export type MenuItemWithAccessControl = MenuItem & {
  isVisible: (userRoles: string[]) => boolean;
};

export const withRolesCheck = (menuItem: MenuItem, roles: string[]): MenuItemWithAccessControl => ({
  ...menuItem,
  isVisible(userRoles: string[]) {
    return roles.every(role => userRoles.includes(role));
  },
});

export const withAllowAny = (menuItem: MenuItem): MenuItemWithAccessControl => ({
  ...menuItem,
  isVisible(_: string[]) {
    return true;
  },
});

export const menuItems: MenuItemWithAccessControl[] = [
  withAllowAny({
    id: '1',
    name: 'Επισκόπηση',
    link: '/',
    icon: 'HomeOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '2',
    name: 'Επαφές',
    link: `/contacts`,
    icon: 'BookOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '2a',
    name: 'Leads',
    link: `/leads`,
    icon: 'PeopleAltOutlined',
    requiredPermissions: ['leads:read'],
  }),
  withAllowAny({
    id: '3',
    name: 'Εταιρείες',
    link: `/companies`,
    icon: 'BusinessOutlined',
    requiredPermissions: ['companies:read'],
  }),
  withAllowAny({
    id: '4',
    name: 'Παραγγελίες',
    link: `/orders`,
    icon: 'ReceiptLongOutlined',
  }),
  withAllowAny({
    id: '5',
    name: 'Υπάλληλοι',
    link: `/employees`,
    icon: 'BadgeOutlined',
  }),
  withAllowAny({
    id: '6',
    name: 'Ημερολόγιο',
    link: `/bookings`,
    icon: 'CalendarMonthOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '7',
    name: 'Υπηρεσίες',
    link: `/services`,
    icon: 'CategoryOutlined',
  }),
  withAllowAny({
    id: '8',
    name: 'Ρυθμίσεις',
    link: `/settings`,
    icon: 'SettingsOutlined',
  }),
];
